import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GraphSummary, ProfitSummary, SalesSummary } from 'src/app/models/inventory.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { DatePickerModel } from '../date-picker-dialog/date-picker.model';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { colorByAccount } from "src/app/core/colorConst";
import { GridActionsService } from 'src/app/data-grid/grid-actions.service';

@Component({
  selector: "app-product-dashboard",
  templateUrl: "./product-dashboard.component.html",
  styleUrls: ["./product-dashboard.component.scss"],
})
export class ProductDashboardComponent implements OnInit, OnDestroy{
  @Input() productId: number;
  @Input() width;
  doughnutChartLabels:any[]=[];
  doughnutChartData:any = [0, 0, 0];
  productRes:any;
  doughnutChartQty:any=[0,0,0];
  chartColors  = ['#0fa1e0',"#8d4b54"];
  public doughnutChartColors:  any[] = [
    {
      backgroundColor: colorByAccount,
    },
  ];
  graphStats;
  graphData;
  height: any = 56;
  salesData: SalesSummary;
  startDate: any;
  endDate: any;
  selectedDateRange: string;
  private destroy$ = new Subject<void>();
  graphSummary: GraphSummary[] = [];
  amazonSummary: any = [];
  walmartSummary: any = [];
  ebaySummary: any = [];
  totalCount: any = 0;
  totalQtySold:any = 0;
  graphLoading: boolean = false;
  graphDetailLoading: boolean = false;
  profitSummary: ProfitSummary;
  dialogRef:any;
  spin:boolean;
  currentDateFilter: DatePickerModel;
  letters = '0123456789ABCDEF';
  color = '#';
  dashboardGrpahData: any[]=[];
  graphLabel: any;
  lineColor=["#5C1DD6","#3A6DFB"]
  tickInterval: any;
  constructor(
    private inventoryService: InventoryService,
    private snackBar: MatSnackBar,
    private dashboardService: DashboardService,
    private gridActionService: GridActionsService
  ) {
     this.dashboardService.selectedDate$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.spin = res?.spinner;
        this.dialogRef = res?.dialogRef; 
        if (res && this.productId) {
          if(res.isGraphDataChange || this.selectedDateRange !== res.selected){
            this.selectedDateRange = res.selected;
            this.ItemGraphDetail(res);
          } else if(!res.isGraphDataChange){
            this.getGrpahSummary(res);
          }
        }
      });
  }

  ngOnInit(): void {
    this.getItemSalesSummary();
    const today = new Date();
    this.currentDateFilter={
      to: today,
      from:new Date(today.getTime() - this.getDaysAgo(30)),
      label:'Last 30 Days'
    }
  }

  getDaysAgo(amountOfDays: number): number {
    return amountOfDays * 24 * 60 * 60 * 1000;
  }

  getItemSalesSummary() {
    this.salesData = null;
    this.inventoryService.ItemSalesSummary(this.productId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        if (res) {
          this.salesData = res;
        }
      },
     error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
      );
       }
   });
  }

  getGrpahSummary(res) {
    this.graphLoading = true;
    if (this.productId) {
      const payload = {
        productId: this.productId,
        startDate: res.startDate,
        endDate: res.endDate,
      };
      this.inventoryService.ItemGraphSummary(payload).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res:any) => {
          this.spin = false;
          this.dialogRef?.close();
          let data: any []= [];
          if (res.length !== 0) {
            this.doughnutChartQty = [];
            this.graphSummary = res;
            this.doughnutChartData = [];
            this.graphSummary.sort((a,b) => a.name.localeCompare(b.name));
            this.graphSummary.forEach((res: any,i)=>{
                data.push([res["name"], res.orders]);
              res.color = colorByAccount[i];
              this.doughnutChartData.push(res.orders)
              this.doughnutChartQty.push(res.qty)
              this.doughnutChartLabels.push(res.name)
            })
            this.graphSummary.sort((a, b) => b.orders - a.orders);
            this.amazonSummary = this.graphSummary.filter((res) =>
              res.type.toLowerCase().includes("amazon")
            );
            this.walmartSummary = this.graphSummary.filter((res) =>
              res.type.toLowerCase().includes("walmart")
            );
            this.ebaySummary = this.graphSummary.filter((res) =>
              res.type.toLowerCase().includes("ebay")
            );
            this.totalCount = this.doughnutChartData?.reduce(
              (accumulator: any, currentValue) => accumulator + currentValue
            );
            this.totalQtySold = this.doughnutChartQty?.reduce(
              (accumulator: any, currentValue) => accumulator + currentValue
            );
            this.productRes ={
              chartType:'doughnut',
              chartLabels:['Fees', 'PPC', 'Profit', 'COGS'],
              chartLegend:false,
              chartColors:this.doughnutChartColors[0].backgroundColor,
              chartData: data,
            }
          }
          this.graphLoading = false;
        },
       error: (err) => {
        this.graphLoading = false;
          this.spin = false;
          this.dialogRef?.close();
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: err.error?.error[0],
                action: 'Dismiss',
                type: 'error',
              },
            }
        );
       }
     });
    }
  }


  getItemProfitSummary(res) {
    this.profitSummary = null;
    if (this.productId) {
      const payload = {
        productId: this.productId,
        startDate: res.startDate,
        endDate: res.endDate,
      };
      this.inventoryService.ItemProfitSummary(payload).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res:any) => {
          this.profitSummary = res;
        },
       error: (err) => {
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: err.error?.error[0],
                action: 'Dismiss',
                type: 'error',
              },
            }
        );
         }
     });
    }
  }

  ItemGraphDetail(res) {
    this.graphDetailLoading = true;
    const payloads = {
      productId: this.productId,
      startDate: res.startDate,
      endDate: res.endDate,
    };
    this.inventoryService.ItemGraphDetail(payloads).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
      if (res) {
        this.spin = false;
        this.dialogRef?.close();
        this.graphLabel =  res.sales.map((res) => res.label);
        this.tickInterval = this.gridActionService.setTickInterval([res?.sales, res?.revenue],7);
        this.dashboardGrpahData=[{
          showInLegend: false,  
          name: "Sales",
          color: '#5C1DD6',
          data: res.sales.map((res) => res.data),
        },
        {
          showInLegend: false,  
          name: "Qty Sold",
          color: '#3A6DFB',
          data: res.revenue.map((res) => res.data),
        },
      ]
        this.graphData = {
          xDataset: res.sales,
          yDataSet: res.revenue,
        }
        this.graphStats = [
          {
            label: 'Sales',
            color: '#5C1DD6'
          },
          {
            label: 'Qty Sold',
            color: '#3A6DFB'
          }
        ]
      }
      this.graphDetailLoading = false;
    },
     error: (err) => {
      this.spin = false;
      this.dialogRef?.close();
      this.graphDetailLoading = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
     }
   });
  }

  getRandomColor() {
    this.color = '#';
    for (var i = 0; i < 6; i++) {
      this.color += this.letters[Math.floor(Math.random() * 16)];
    }
    return this.color;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
